module.exports = __webpack_public_path__ + "static/media/0037.b7f2822d.svg";